'use client';

// Components
import HomepageBanner from '@src/components/organism/article/homepage-banner';
import ListArticle from '@src/components/organism/article/list-article';
import Subscription from '@src/components/organism/article/subscription';

// Components shared
import GoldenProperty from '@src/components/organism/shared/golder-property';
import Navbar from "@src/components/organism/shared/navbar";
import NavbarMobile from "@src/components/organism/shared/navbar-mobile";
import Footer from "@src/components/organism/shared/footer";


const ArticleHomepage = () => {
  return (
    <div>
      <Navbar />
      <div className="hidden dd2-xl:block">
        <NavbarMobile />
      </div>

      <HomepageBanner />
      <ListArticle />
      <Subscription />
      <GoldenProperty />
      <Footer />
    </div>
  );
};

export default ArticleHomepage;
